function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-16 -27)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.159 36.452h-1.64v1.922h1.64a1.138 1.138 0 00.775-.229.953.953 0 00.257-.746.91.91 0 00-.257-.722 1.153 1.153 0 00-.775-.225z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.32,
  cy: 4.32,
  r: 4.32,
  transform: "translate(46.538 52.346)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.32,
  cy: 4.32,
  r: 4.32,
  transform: "translate(22.677 52.346)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.262 34.856a2.89 2.89 0 00-2.544-1.52h-4.725a.462.462 0 01-.462-.462v-4.146A1.728 1.728 0 0044.8 27H17.728A1.728 1.728 0 0016 28.728v25.346a1.728 1.728 0 001.728 1.726h3.29a6.041 6.041 0 0111.96 0h11.9a6.041 6.041 0 0111.96 0H58.8a.976.976 0 00.976-.976V45.1zm-30.114 1.692h-3.3v1.577h2.858v1.166h-2.857v2.82h-1.5v-6.825h4.8zm5.252 5.564a2.637 2.637 0 01-.153-.774q-.029-.449-.086-.861a1.356 1.356 0 00-.325-.784 1.119 1.119 0 00-.813-.248h-1.5v2.667h-1.5v-6.826H28.7a2.188 2.188 0 01.827.148 1.888 1.888 0 01.631.406 1.754 1.754 0 01.4.6 1.91 1.91 0 01.139.732 2.054 2.054 0 01-.254 1.042 1.591 1.591 0 01-.827.669v.017a1.157 1.157 0 01.459.234 1.307 1.307 0 01.3.373 1.711 1.711 0 01.167.473 4.081 4.081 0 01.072.517q.01.162.019.382c.006.146.018.3.033.449a2.954 2.954 0 00.077.435 1 1 0 00.158.349zm7.706 0H31.92v-6.826h5.1v1.262h-3.6v1.463h3.308v1.167h-3.307v1.672H37.1zm6.2 0h-5.19v-6.826h5.1v1.262h-3.6v1.463h3.308v1.167h-3.308v1.672H43.3zM56.285 44.5h-4.007c-1.364 0-2.728-.007-4.092.006-.269 0-.361-.051-.359-.344q.019-3.855 0-7.71c0-.277.081-.328.337-.324 1.148.014 2.3.025 3.445 0a1.085 1.085 0 011.054.637c.732 1.352 1.438 2.717 2.171 4.069.574 1.059 1.18 2.1 1.759 3.158.262.476.233.508-.308.508z"
}));

function SvgIconMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42.508 32.487"
  }, props), _ref);
}

export default SvgIconMessage;